import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export default function getProviderTypeFromAddProviderRedirectUrl(
    urlParameters: any
): AttachmentDataProviderType {
    let providerType: AttachmentDataProviderType = urlParameters.provider
        ? parseInt(urlParameters.provider)
        : null;

    if (!providerType && urlParameters.state) {
        // This happens only in case of GDrive
        const stateDict = JSON.parse(urlParameters.state);

        if (stateDict) {
            providerType = stateDict.provider ? parseInt(stateDict.provider) : null;
        }
    }

    return providerType;
}
